/**
 * Multi-tenant branding config.
 *
 * The active brand is picked at boot from the REACT_APP_BRAND env var
 * (set per-deployment in that environment's .env). One deployment per client
 * keeps their data isolated — a hard requirement for government tenants.
 *
 * Adding a new client:
 *   1) Drop a logo into /app/frontend/public/branding/<slug>-logo.png
 *   2) Add a new entry in BRANDS below
 *   3) Set REACT_APP_BRAND=<slug> in that client's deployment
 *
 * All brands share the "Powered by smScope" footer, so no per-brand override
 * of that asset is exposed here.
 */

export const BRANDS = {
  mdc: {
    id: "mdc",
    // Shown in the browser title and internal references
    productName: "SoilHaul for MDC",
    // Shown under the main logo in the sidebar
    tagline: "Logistics Ops",
    // Optional secondary brand block ("This deployment is for X") — kept for
    // MDC because that's how the app currently reads to their users.
    clientBrand: {
      logo: "/mdc/mdc-logo.png",
      name: "The Metropolitan District",
      location: "Hartford, CT",
      // Label above the client name. MDC is the customer being served.
      relationLabel: "Serving",
    },
  },
  stg: {
    id: "stg",
    productName: "SoilHaul",
    tagline: "Soil Tracking · Chain of Custody",
    // STG is the vendor themselves — show their logo in the sidebar
    // client-brand block so it reads as "delivered by Singh Technology Group".
    clientBrand: {
      logo: "/branding/stg-logo.png",
      name: "Singh Technology Group",
      location: null,
      // STG is delivering/servicing SoilHaul, not being served by it.
      relationLabel: "Serviced by",
    },
  },
};

const DEFAULT_BRAND = "stg";

// Read once at module load so React never sees a mid-boot flicker.
const active = (process.env.REACT_APP_BRAND || DEFAULT_BRAND).toLowerCase();

export const brand = BRANDS[active] || BRANDS[DEFAULT_BRAND];
